import { useSyncExternalStore } from 'react'

export type OpenedVerification = { formId: string; verificationId: string }

// The verification form open on a page that doesn't carry it in the URL (/onboarding keeps it out
// of the address bar). The public-forms request interceptor and the form's own widgets fall back
// to it when there is no `verificationId` search param.
let opened: OpenedVerification | null = null
const listeners = new Set<() => void>()

export const getOpenedVerification = (): OpenedVerification | null => opened

export const setOpenedVerification = (next: OpenedVerification | null) => {
  if (opened?.formId === next?.formId && opened?.verificationId === next?.verificationId) return
  opened = next
  listeners.forEach((listener) => listener())
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const useOpenedVerification = (): OpenedVerification | null =>
  useSyncExternalStore(subscribe, getOpenedVerification, getOpenedVerification)
